var _a;
export var TableFieldType;
(function (TableFieldType) {
    TableFieldType["Model"] = "model";
    TableFieldType["Custom"] = "custom";
})(TableFieldType || (TableFieldType = {}));
export var TableSelectionAction;
(function (TableSelectionAction) {
    TableSelectionAction["POST_SUBMIT"] = "post-submit";
    TableSelectionAction["DELETION"] = "deletion";
    TableSelectionAction["FIELD_ONLY"] = "field-only";
})(TableSelectionAction || (TableSelectionAction = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["None"] = "none";
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection || (SortDirection = {}));
export var SortDirectionPrefix = (_a = {},
    _a[SortDirection.None] = '',
    _a[SortDirection.Asc] = '',
    _a[SortDirection.Desc] = '-',
    _a);
export var PageJumpMethod;
(function (PageJumpMethod) {
    PageJumpMethod["Previous"] = "previous";
    PageJumpMethod["Next"] = "next";
    PageJumpMethod["Direct"] = "direct";
    PageJumpMethod["Dropdown"] = "dropdown";
})(PageJumpMethod || (PageJumpMethod = {}));
export var SortAction;
(function (SortAction) {
    SortAction["Sort"] = "sort";
    SortAction["Remove"] = "remove";
})(SortAction || (SortAction = {}));
var TableFilter = /** @class */ (function () {
    function TableFilter() {
    }
    return TableFilter;
}());
export { TableFilter };
export var FilterApplyMode;
(function (FilterApplyMode) {
    FilterApplyMode["OnChange"] = "apply-on-change";
    FilterApplyMode["OnSubmit"] = "apply-on-submit";
})(FilterApplyMode || (FilterApplyMode = {}));
export var TableLayout;
(function (TableLayout) {
    TableLayout["LAYOUT_RESPONSIVE"] = "responsive";
    TableLayout["LAYOUT_FORCE_STACKED"] = "force-stacked";
    TableLayout["LAYOUT_FORCE_TABLE"] = "force-table";
})(TableLayout || (TableLayout = {}));
export var TableRequestType;
(function (TableRequestType) {
    TableRequestType["UPDATE"] = "update";
    TableRequestType["DOWNLOAD_EXCEL"] = "download-excel";
})(TableRequestType || (TableRequestType = {}));
